import type { Activity } from "~/models";

const activities: Activity[] = [
    {
        id: "info",
        name: "Information Gathering",
    },
    {
        id: "idea",
        name: "Idea Work",
    },
    {
        id: "analysis",
        name: "Analysis/Strategy",
    },
    {
        id: "development",
        name: "Development",
    },
    {
        id: "art",
        name: "Art Direction",
    },
];

export default activities;
